import React, { useMemo } from 'react'
import { Grid } from '@design-systems/canvas-ui'
import { buildBannerText } from '../../../../globalComponents/Builders'
import {
  NON_COMPLIANT_BANNER,
  LOCATION_ARCHIVED_BANNER,
} from '../../../../common/commonConstants'
import { HeaderBanner } from '../../../../common'

const Rfi3Banner = ({ rfi3Data, rfi3Template }) => {
  const message = useMemo(() => {
    const isNonCompliant = rfi3Data?.non_compliant
    const isArchived = rfi3Data?.archived

    if (!isNonCompliant && !isArchived) return null

    const sections = rfi3Template?.fixed_sections?.sections || []
    const controls = sections[0]?.controls || []

    if (isNonCompliant) {
      const nonCompliantControl = controls.find(
        (c) => c.component_name === NON_COMPLIANT_BANNER,
      )
      if (!nonCompliantControl) return null

      return buildBannerText(
        nonCompliantControl.label_name,
        rfi3Data.fixed_sections?.factory_contact_information?.[
          nonCompliantControl.uid
        ],
      )
    }

    if (isArchived) {
      const archivedControl = controls.find(
        (c) => c.component_name === LOCATION_ARCHIVED_BANNER,
      )
      return archivedControl?.label_name
    }

    return null
  }, [rfi3Data, rfi3Template])

  if (!message) return null

  return (
    <Grid.Container
      spacing="normal"
      justify="space-between"
      className="hc8-ph-4x hc8-mb-none"
    >
      <Grid.Item size={{ xs: 12 }} className="hc8-ph-6x hc8-pv-none">
        <HeaderBanner bannerText={message} />
      </Grid.Item>
    </Grid.Container>
  )
}

export default React.memo(Rfi3Banner)
